var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"analysis-results-overview-modal","classes":['modal-window'],"transition":"scale","scrollable":"","adaptive":"","click-to-close":false,"width":"800px","height":"auto"}},[_c('analysis-results-overview',{staticClass:"modal-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }